import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'app/auth.service';
import { DataService } from 'app/data.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-manage-properties',
  templateUrl: './manage-properties.component.html',
  styleUrls: ['./manage-properties.component.css']
})
export class ManagePropertiesComponent implements OnInit {

  status = 'pending'

  properties = []

  page: number = 1

  lastpage: number

  loading: boolean

  searchHeader: string

  searchValue: string

  searchDisabled: boolean = true

  constructor( private adminService: DataService, private auth: AuthService, private notification: MatSnackBar, private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        if(params.status) {
          this.status = params.status
        }
        this.getProperties()
      });
    if(this.searchHeader && this.searchValue){
      this.searchDisabled = false
    }
  }

  checkIfSearchDisabled(){
    if(this.searchHeader && this.searchValue){
      this.searchDisabled = false
    }else{
      this.searchDisabled = true
    }
    console.log(this.searchDisabled)
  }

  search(){
    this.searchDisabled = true
    this.loading = true
    this.adminService.searchPropertyByAdmin(this.searchHeader, this.searchValue).subscribe(data => {
      if(data.status){
        this.properties = []
        let properties = data.propertiesAd
        if(properties.length > 0){
          for(let property of properties){
            property['previewLink'] = environment.url + '/property-preview/'+property.id+'?token='+this.auth.accessToken
            if(property.status == 'pending'){
              property['approvalDate'] = this.formatDate(property.createdAt)
            }
            property['paymentInfo'] = this.getPaymentInfo(property)
            this.adminService.getOneUser(property.user_id).subscribe((data: { user: any })=> {
              property['sellerFName'] = data.user.firstName;
              property['sellerLName'] = data.user.lastName;
              this.properties.push(property)
            })
          }
        }
        this.lastpage = Math.ceil(data.total/10)
      }
      this.searchDisabled = false
      setTimeout(()=> {
        this.loading = false
      }, 500)
    }, error => {
      this.searchDisabled = false
      this.loading = false
      this.properties = []
      if(error.status){
        this.openNotification(error.error.message)
      }
    })
  }

  changeRoute(){
    this.router.navigate(
      ['.'], 
      {
        relativeTo: this.route,
        queryParams: { status: this.status },
        queryParamsHandling: 'merge'
      });
  }

  getProperties(){
    this.loading = true
    this.properties = []
    let offset = (this.page - 1)*10
    
    this.adminService.getProperties(this.status, offset).subscribe(data => {
      console.log(data)
      if(data.status){
        let properties = data.propertiesAd
        if(properties.length > 0){
          for(let property of properties){
            property['previewLink'] = environment.url + '/property-preview/'+property.id+'?token='+this.auth.accessToken
            if(property.status == 'pending'){
              property['approvalDate'] = this.formatDate(property.createdAt)
            }
            property['paymentInfo'] = this.getPaymentInfo(property)
            this.adminService.getOneUser(property.user_id).subscribe((data: { user: any })=> {
              property['sellerFName'] = data.user.firstName;
              property['sellerLName'] = data.user.lastName;
              this.properties.push(property)
            })
          }
        }
        this.lastpage = Math.ceil(data.total/10)
      }
      setTimeout(()=> {
        this.loading = false
      }, 500)
    }, error => {
      this.loading = false
      if(error.status == 404){
        this.properties = []
      }
    })
  }

  getPaymentInfo(property: any): string {
    const bankPay = property.BankPayment || (Array.isArray(property.BankPayments) && property.BankPayments[0]);
    if (bankPay && (bankPay.status !== undefined || bankPay.remarks || bankPay.id)) {
      const status = (bankPay.status === true || bankPay.status === 1 || bankPay.status === 'true' || bankPay.status === '1') ? 'Verified' : 'Not Verified';
      return `Bank Deposit | ${status}`;
    }
    const trans = property.Transaction || (Array.isArray(property.Transactions) && property.Transactions[0]);
    if (trans && (trans.paymentMethod || trans.status !== undefined || trans.id)) {
      let method = trans.paymentMethod ? trans.paymentMethod : 'Transaction';
      if (method === 'Bank Payment') {
        method = 'Bank Deposit';
      }
      const status = (trans.status === true || trans.status === 1 || trans.status === 'true' || trans.status === '1') ? 'Verified' : 'Not Verified';
      return `${method} | ${status}`;
    }
    return 'N/A';
  }

  formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
  }

  firstPage(){
    if(this.page != 1){
      this.page = 1
      this.loading = true
      this.getProperties()
    }
  }

  previousPage(){
    if(this.page > 1){
      this.page = this.page - 1
      this.loading = true
      this.getProperties()
    }
  }

  nextPage(){
    if(this.page < this.lastpage){
      this.page = this.page + 1
      this.loading = true
      this.getProperties()
    }
  }

  lastPage(){
    if(this.page != this.lastpage){
      this.page = this.lastpage
      this.loading = true
      this.getProperties()
    } 
  }

  openNotification(msg){
    this.notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

}
